import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import colorConstants from '../../../constants/colorConstants';

const jsonValidationStyles = makeStyles((theme: Theme) =>
  createStyles({
    validationResStyle: {
      position: 'absolute',
      maxWidth: 400,
      top: '90px',
      right: '270px',
      border: '2px solid #000',
      boxShadow: '5px 10px 10px grey',
      display: 'flex',
      flexDirection: 'column',
    },
    boxStyle: {
      position: 'absolute',
      maxWidth: 400,
      top: '80px',
      right: '15px',
      border: '2px solid #000',
      boxShadow: '5px 10px 10px grey',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      backgroundColor: '#1976d2',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      zIndex: 10,
    },
    flexRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    flexWrap: {
      flexWrap: 'wrap',
    },
    flexCol: {
      display: 'flex',
      flexDirection: 'column',
    },
    headerLeft: {
      padding: '5px 0 5px 10px',
      flex: 1,
    },
    searchTitle: {
      fontSize: 20,
      fontWeight: 600,
    },
    searchBody: {
      zIndex: 10,
      backgroundColor: '#FFF',
      maxHeight: '70vh',
      overflowY: 'auto',
    },
    alignCenter: {
      alignItems: 'center',
    },
    // legendBar: {
    //   backgroundColor: '#1976d2',
    //   display: 'flex',
    //   flexDirection: 'row',
    //   justifyContent: 'space-between',
    //   zIndex: 10,
    //   // paddingLeft: 10,
    //   paddingBottom: 10,
    // },
    // headerRight: {
    //   width: 30,
    //   marginTop: 5,
    // },
    // legend: {
    //   display: 'flex',
    //   flexDirection: 'row',
    //   flexWrap: 'nowrap',
    //   marginRight: 20,
    // },
    // legendColor: {
    //   border: '1px solid black',
    //   width: 30,
    //   height: 20,
    //   marginRight: 5,
    // },
    // preconditionLegend: { background: colorConstants.CURRENTJOURNEY_PRECONDITION_COLOR },
    // orchStepLegend: { background: colorConstants.CURRENTJOURNEY_ORCHSTEP_COLOR },
    // selectedLegend: { background: colorConstants.SELECTED_COLOR },
    compResult: {
      padding: '5px',
      cursor: 'pointer',
      '&:hover': {
        opacity: '0.9',
      },
      '& > ol': {
        margin: 2,
        paddingInlineStart: 30,
      },
    },
    // preconditionSearched: {
    //   background: colorConstants.CURRENTJOURNEY_PRECONDITION_COLOR,
    //   '&:hover': {
    //     opacity: '0.9',
    //   },
    // },
    // selected: {
    //   background: '#90EE90',
    // },
    // delete: {
    //   border: '1px solid grey',
    //   marginRight: '1rem',
    //   cursor: 'pointer',
    //   backgroundColor: 'red',
    // },
    // noResult: {
    //   borderBottom: '1px solid grey',
    //   wordBreak: 'break-word',
    //   padding: 10,
    // },
    // entry: {
    //   wordBreak: 'break-word',
    //   display: 'flex',
    //   flexDirection: 'column',
    // },
    // unselected: {
    //   '&:hover': {
    //     backgroundColor: '#f3f3f3',
    //   },
    // },
    // indent: {
    //   marginLeft: 10,
    // },

    // mt1: {
    //   marginTop: '1rem',
    // },
    // mb1: {
    //   marginBottom: '1rem',
    // },
    // orchStep: {
    //   borderBottom: '1px solid grey',
    //   padding: '0 10px',
    // },
    // flexExpand: {
    //   flex: 1,
    // },
    pointer: {
      cursor: 'pointer',
      color: '#1976d2',
    },
  }),
);

export { jsonValidationStyles };
